import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Crown, Store, TrendingUp, MapPin, Camera, Trophy } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export const PlayerAvatar = ({ player, size = "w-10 h-10", text = "text-sm" }) => (
  <div className={`${size} rounded-full bg-gradient-to-br from-pink-500 to-purple-600 flex items-center justify-center overflow-hidden flex-shrink-0 border border-white/10`}>
    {player?.Photo ? <img src={player.Photo} alt="" className="w-full h-full object-cover" onError={(e) => { e.target.style.display = "none"; }} /> : <span className={`text-white font-bold ${text}`}>{player?.Nombre?.charAt(0) || "?"}</span>}
  </div>
);

export const WeeklySpotlight = ({ seasonId, isAdmin, onPhotoEdit, refreshKey }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const params = seasonId ? `?season_id=${seasonId}` : "";
    axios.get(`${API}/ranking/spotlight${params}`).then((r) => setData(r.data)).catch(() => setData(null));
  }, [seasonId, refreshKey]);

  const s = data?.spotlight;
  if (!s) return null;
  const p = s.player;

  return (
    <div className="relative rounded-2xl overflow-hidden mb-8 border border-yellow-400/40 shadow-[0_0_60px_rgba(250,204,21,0.15)]" data-testid="weekly-spotlight">
      <div className="absolute inset-0 bg-gradient-to-r from-yellow-500/15 via-purple-900/40 to-pink-500/15" />
      <div className="absolute -top-16 -right-16 w-56 h-56 rounded-full bg-yellow-400/20 blur-3xl animate-pulse" />
      <div className="relative p-5 md:p-7 flex flex-col md:flex-row md:items-center gap-5">
        <div className="relative group">
          <div className="absolute -inset-1 rounded-full bg-gradient-to-r from-yellow-400 via-pink-500 to-yellow-400 blur-sm opacity-80 animate-[spin_6s_linear_infinite]" />
          <div className="relative">
            <PlayerAvatar player={p} size="w-24 h-24 md:w-28 md:h-28" text="text-4xl" />
            {isAdmin && (
              <button onClick={() => onPhotoEdit(p)} className="absolute bottom-0 right-0 p-1.5 rounded-full bg-green-500 text-black shadow" title="Cambiar foto" data-testid="spotlight-photo-btn"><Camera size={13} /></button>
            )}
          </div>
          <Crown size={28} className="absolute -top-4 left-1/2 -translate-x-1/2 text-yellow-400 drop-shadow-[0_0_10px_rgba(250,204,21,0.8)]" />
        </div>

        <div className="flex-1 min-w-0">
          <p className="text-[11px] tracking-[0.3em] font-black text-yellow-400 mb-1">WEEKLY SPOTLIGHT · {s.week}</p>
          <Link to={`/jugador/${encodeURIComponent(p.Nombre || "")}`} className="block text-2xl md:text-3xl font-black text-white leading-tight truncate hover:text-yellow-300 transition-colors" data-testid="spotlight-player-name">{p.Nombre}</Link>
          <p className="text-sm text-gray-300 mt-1">
            {s.mode === "tournament_win" ? <><Trophy size={14} className="inline text-yellow-400 mr-1" />Campeón de <Link to={s.tournament?.id ? `/torneos/${s.tournament.id}` : "/torneos"} className="text-yellow-300 font-bold hover:underline">{s.tournament?.nombre}</Link>{s.tournament?.deck && <> con <span className="text-pink-300 font-semibold">{s.tournament.deck}</span></>} · <span className="text-emerald-300 font-bold">+{s.points_gained} pts</span></> : s.mode === "weekly_gain" ? <><TrendingUp size={14} className="inline text-emerald-400 mr-1" />Campeón de la semana con <span className="text-emerald-300 font-bold">+{s.points_gained} pts</span></> : <>Líder de {data.season?.nombre || "la temporada"} con <span className="text-yellow-300 font-bold">{p.Total} pts</span></>}
            {(p.Equipo || p.Comunidad) && <span className="ml-2 px-2 py-0.5 rounded bg-purple-800/60 text-purple-200 text-xs">{p.Equipo || p.Comunidad}</span>}
          </p>
        </div>

        {s.store && (
          <a href={s.store.maps_url || "#"} target="_blank" rel="noreferrer" className="flex items-center gap-3 px-4 py-3 rounded-xl bg-black/40 border border-purple-500/40 hover:border-yellow-400/60 transition" data-testid="spotlight-store">
            <div className="w-11 h-11 rounded-lg bg-purple-900/70 flex items-center justify-center text-yellow-400 overflow-hidden">{s.store.logo_url ? <img src={s.store.logo_url} alt="" className="w-full h-full object-cover" /> : <Store size={20} />}</div>
            <div><p className="text-[10px] tracking-widest text-gray-400">SEDE DEL TRIUNFO</p><p className="font-bold text-white text-sm">{s.store.nombre}</p><p className="text-[11px] text-gray-400 flex items-center gap-1"><MapPin size={10} /> {s.store.ciudad}</p></div>
          </a>
        )}
      </div>
    </div>
  );
};
